import * as THREE from 'three';

export class CncEstimator {

    constructor(public material: 'aluminium' | 'steel' = 'aluminium') {}

    // Geometry hacmini hesapla (mm³ cinsinden)
    public geometryVolume(geom: THREE.BufferGeometry): number {
        const pos = geom.attributes.position.array as Float32Array;
        const index = geom.index?.array as Uint16Array | Uint32Array | undefined;

        let volume = 0;

        if (index) {
            for (let i = 0; i < index.length; i += 3) {
                const a = new THREE.Vector3(pos[index[i]*3], pos[index[i]*3+1], pos[index[i]*3+2]);
                const b = new THREE.Vector3(pos[index[i+1]*3], pos[index[i+1]*3+1], pos[index[i+1]*3+2]);
                const c = new THREE.Vector3(pos[index[i+2]*3], pos[index[i+2]*3+1], pos[index[i+2]*3+2]);
                volume += a.dot(b.clone().cross(c)) / 6;
            }
        } else {
            for (let i = 0; i < pos.length; i += 9) {
                const a = new THREE.Vector3(pos[i], pos[i+1], pos[i+2]);
                const b = new THREE.Vector3(pos[i+3], pos[i+4], pos[i+5]);
                const c = new THREE.Vector3(pos[i+6], pos[i+7], pos[i+8]);
                volume += a.dot(b.clone().cross(c)) / 6;
            }
        }

        return Math.abs(volume); // mm³ cinsinden
    }

    // Geometry yüzey alanını hesapla (mm² cinsinden)
    public geometrySurfaceArea(geom: THREE.BufferGeometry): number {
        const pos = geom.attributes.position.array as Float32Array;
        const index = geom.index?.array as Uint16Array | Uint32Array | undefined;

        let area = 0;
        const v0 = new THREE.Vector3();
        const v1 = new THREE.Vector3();
        const v2 = new THREE.Vector3();

        if (index) {
            for (let i = 0; i < index.length; i += 3) {
                v0.set(pos[index[i]*3], pos[index[i]*3+1], pos[index[i]*3+2]);
                v1.set(pos[index[i+1]*3], pos[index[i+1]*3+1], pos[index[i+1]*3+2]);
                v2.set(pos[index[i+2]*3], pos[index[i+2]*3+1], pos[index[i+2]*3+2]);
                area += v1.clone().sub(v0).cross(v2.clone().sub(v0)).length() / 2;
            }
        } else {
            for (let i = 0; i < pos.length; i += 9) {
                v0.set(pos[i], pos[i+1], pos[i+2]);
                v1.set(pos[i+3], pos[i+4], pos[i+5]);
                v2.set(pos[i+6], pos[i+7], pos[i+8]);
                area += v1.clone().sub(v0).cross(v2.clone().sub(v0)).length() / 2;
            }
        }

        return area; // mm² cinsinden
    }

    // CNC süresi tahmini (dakika), mm³ üzerinden
    public estimateCncTime(volumeMm3: number): number {
        // Varsayılan MRR değerleri (mm³/dak)
        const roughMrr = this.material === 'aluminium' ? 6000 : 3000;
        const finishMrr = this.material === 'aluminium' ? 6000 : 3000;

        const roughVolume = volumeMm3 * 0.9; // %90 kaba
        const finishVolume = volumeMm3 * 0.5; // %10 bitirme

        const roughTime = roughVolume / roughMrr;
        const finishTime = finishVolume / finishMrr;

        const miscTime = 0.5; // toolchange + probing

        return roughTime + finishTime + miscTime; // dakika
    }

    // Tek adımda tahmin
    public estimateFromGeometry(geom: THREE.BufferGeometry): number {
        const vol = this.geometryVolume(geom);
        return this.estimateCncTime(vol);
    }
}
